import * as React from "react";
import cx from "classnames";
import LegacyText from "components/LegacyText";
import { GigFull, WorkflowState } from "interfaces/Gig";
import ReportStatus from "../GigInfo/ReportStatus";
import styles from "./styles.scss";

function getStateClass(state?: WorkflowState) {
  switch (state) {
    case "verified":
      return styles.verified;
    case "reportVerificationRejected":
      return styles.rejected;
    default:
      return "";
  }
}

interface Props {
  agencyName?: string;
  clientName: string;
  logoUrl?: string | null;
  gig?: { compareWorkflowStateOrder: number } & GigFull;
  goBackUrl: string;
}

export default function ReportHeader({ agencyName, clientName, gig, goBackUrl }: Props) {
  return (
    <div className={cx(styles.header, gig && getStateClass(gig.workflowStateKey))}>
      <div className={styles.headerContent} data-test={"gogetter.gigInfo.clientAgencyAndTitle"}>
        <div className={styles.topHeader}>
          <a href={goBackUrl}>
            <LegacyText.Display4 kind="reverse" className={styles.backButtonLabel}>
              Go Back
            </LegacyText.Display4>
          </a>
          <div>
            <LegacyText.Display4 kind="reverse" className={styles.title}>
              {agencyName ? agencyName : clientName}
            </LegacyText.Display4>
          </div>
        </div>
        <LegacyText.P kind="reverse" className={styles.gigTitle}>
          {gig?.title}
        </LegacyText.P>

        {gig && gig.compareWorkflowStateOrder >= 0 && (
          <ReportStatus
            state={gig.workflowStateKey}
            message={gig.reportReviewMessage}
            reviewedByName={
              gig.reportReviewedBy ? `${gig.reportReviewedBy.firstName} ${gig.reportReviewedBy.lastName}` : null
            }
            reviewedByOrganization={agencyName || clientName}
          />
        )}
      </div>
    </div>
  );
}
